import {
  fetchGenericDateBreakdown,
  TEASER_COLUMN_CONFIG,
  DateBreakdownRow
} from './dateBreakdownExportGeneric'

export const fetchTeaserDateBreakdown = async (
  cubejsApi: any,
  campaignId: string,
  dateRange: string[],
  filters: any[],
  teasers: any[],
  companyType: string,
  visibleColumns: string[]
): Promise<DateBreakdownRow[]> => {
  return fetchGenericDateBreakdown(
    cubejsApi,
    campaignId,
    dateRange,
    filters,
    visibleColumns,
    companyType,
    TEASER_COLUMN_CONFIG,
    'teaser',
    (utmSource) => utmSource === '' || utmSource === 'ADSERVER'
  )
}
